import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Lenis from 'lenis'
import { logger, Viewport } from './utils'
import { hoverImageTransition } from './archive'
import { headingAnimation, imageRevealAnimation } from './commonAnimations'
import { pageLoadAnimation } from './pageTransition'

const menuAnimation = () => {
  const blurBG = document.querySelector('.menu--bg-blur')
  // const menuToggle = document.querySelector('.menu-sidebar__toggle')
  const menuSidebarWrapper = document.querySelector('.menu--sidebar__wrapper')
  const menuOpener = document.querySelector('.menu-sidebar__opener')
  const menuCloser = document.querySelector('.menu-sidebar__closer')

  const tl = gsap.timeline({
    defaults: { duration: 1, ease: 'power4.inOut' },
    paused: true,
  })

  tl.set(menuCloser, { opacity: 0 }).set(menuSidebarWrapper, { willChange: 'transform' })

  tl.add('start', 0)

  tl.to(menuSidebarWrapper, { x: '0%' }, 'start')
    .to(
      blurBG,
      {
        opacity: 1,
        pointerEvents: 'all',
      },
      'start'
    )
    .to(
      menuCloser,
      {
        opacity: 1,
        duration: 0.5,
      },
      'start+=0.5'
    )
    .to(
      menuOpener,
      {
        opacity: 0,
        duration: 0.5,
      },
      'start'
    )

  menuOpener?.addEventListener('click', () => {
    document.body.style.overflow = 'hidden'
    window.lenis?.stop()
    tl.play()
  })
  menuCloser?.addEventListener('click', () => {
    document.body.style.overflow = 'auto'
    window.lenis?.start()
    tl.reverse()
  })
  blurBG?.addEventListener('click', () => {
    document.body.style.overflow = 'auto'
    window.lenis?.start()
    tl.reverse()
  })

  return { tl }
}

function registerLenisAndScrollTrigger() {
  // kill all the scroll triggers and lenis instances before creating new ones
  ScrollTrigger.getAll().forEach((trigger) => trigger.kill())
  let lenis = window.lenis as Lenis | undefined
  if (lenis) {
    lenis.destroy()
  }

  gsap.registerPlugin(ScrollTrigger)

  lenis = new Lenis({
    duration: 1.5,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  })
  window.lenis = lenis

  function raf(time: number) {
    lenis!.raf(time)
    ScrollTrigger.update()
    requestAnimationFrame(raf)
  }

  requestAnimationFrame(raf)

  return { lenis, ScrollTrigger }
}

function animatedBoxAnimation() {
  const boxesParents = document.querySelectorAll('.animated-box-list')

  boxesParents.forEach((boxesParent) => {
    const boxes = boxesParent?.querySelectorAll('.animated-box-list__item')

    if (!boxesParent || !boxes?.length) return logger.info('No Animated boxes found')
    if (Viewport.width() <= 700) return logger.info('Animated box animation Not running on Tablet or Mobile')

    const tl = gsap.timeline({
      defaults: { duration: 1, ease: 'none' },
      paused: true,
      scrollTrigger: {
        trigger: boxesParent,
        start: 'top 90%',
        end: 'bottom -10%',
        scrub: 0.5,
      },
    })

    tl.add('start', 0)
    tl.to(boxes[0], { x: '25%' }, 'start')
    tl.to(boxes[2], { x: '-25%' }, 'start')
  })
}

function animatedBoxAnimationColumns() {
  const boxesParents = document.querySelectorAll('.animated-box-list-cols')

  boxesParents.forEach((boxesParent) => {
    const boxes = boxesParent?.querySelectorAll('.animated-box-cols-list__item')

    if (!boxesParent || !boxes?.length) return logger.info('No Animated boxes found')
    if (Viewport.width() <= 700) return logger.info('Animated box animation Not running on Tablet or Mobile')

    const tl = gsap.timeline({
      defaults: { duration: 1, ease: 'none' },
      paused: true,
      scrollTrigger: {
        trigger: boxesParent,
        start: 'top 90%',
        end: 'bottom -10%',
        scrub: 0.5,
      },
    })

    tl.add('start', 0)
    tl.fromTo(boxes[0], { y: '25%' }, { y: '-25%' }, 'start')
    tl.fromTo(boxes[2], { y: '-25%' }, { y: '25%' }, 'start')
  })
}

function pageLoadHandler() {
  // always move page on top when page is loaded & also move up when leaving the page
  window.scrollTo(0, 0)
  window.addEventListener('beforeunload', () => {
    window.scrollTo(0, 0)
  })
}

function afterPageAnimationHandler() {
  // headingAnimation()
  // imageRevealAnimation()
  window.pageLoadAnimationCompleted = true
  const event = new CustomEvent('pageLoadAnimationCompleted')
  window.dispatchEvent(event)
  logger.info('pageLoadAnimationCompleted event dispatched')
}

// use a script tag or an external JS file
document.addEventListener('DOMContentLoaded', async () => {
  if (window.localhostMainScriptHasRun) return logger.info('Main script already run with localhost')
  const { tl } = menuAnimation()
  pageLoadAnimation({
    afterPageLoadCallback: afterPageAnimationHandler,
    hideSidebarMenu: function () {
      tl.reverse()
    },
  })
  pageLoadHandler()
  registerLenisAndScrollTrigger()
  headingAnimation()
  imageRevealAnimation()
  animatedBoxAnimation()
  animatedBoxAnimationColumns()
  hoverImageTransition()

  window.localhostMainScriptHasRun = true
})
